import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import {
  TextField,
  MenuItem,
  Button,
  Stack,
  IconButton,
  Collapse,
  Typography,
  Menu,
  CircularProgress,
  Paper,
  Grid,
  ListItemIcon, ListItemText,
  SvgIcon
} from "@mui/material";
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ProjectDetailTaskRow from "./ProjectDetailTaskRow";
import { TrueffortButton, TrueffortChip } from "../../MUIstyle/MUICustom";
import { Delete as DeleteIcon, Edit as EditIcon, Close as CloseIcon, Save as SaveIcon, BorderRight } from '@mui/icons-material';
import ProjectPhaseService from "../../services/projectPhase.service";
import PendingIcon from "@mui/icons-material/Pending";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { formatSeconds } from "../../util/GlobalFunctions";
import { TaskTypesContext } from "./ProjectDetailContext";
import { useAuthContext } from "../../contexts/AuthenticationContext";
import { MIN_LEVEL_LEADER } from "../../util/Constants";
import { User } from "../../models/user";
import TrueffortChipStatus from "./TrueffortChipStatus";

export type PhaseType = {
  name: string
  duration: number
};

// @ts-ignore
function ProjectDetailPhaseRow({ el, phase, /*phaseType,*/ users, states, _fillProjectInfo, hidePhaseAndTask, project, tasks, priorityTypes, hasSecuency }) {
  //console.log(phaseType);
  const { t } = useTranslation();
  const { user } = useAuthContext() as { user: User };

  const taskTypes = useContext(TaskTypesContext);

  const [open, setOpen] = React.useState(hidePhaseAndTask);
  const [isEditing, setIsEditing] = React.useState(false);
  const [showLoading, setShowLoading] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openOptions = Boolean(anchorEl);
  const projectPhaseService = React.useMemo(() => new ProjectPhaseService(), []);

  const handleClickOptions = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseOptions = () => {
    setAnchorEl(null);
  };

  const validate = (values: PhaseType) => {
    let errors: any = {};
    if (!values.duration) {
      errors.duration = " ";
    }
    if (values.duration < 0) {
      errors.duration = t("project_tasks_page.msg_duration_negative");
    }
    return errors;
  }

  const handleSubmit = (values: any) => {
    setAnchorEl(null);
    let phAux = {
      name: values.name,
      estimatedDays: values.duration
    }

    // @ts-ignore
    projectPhaseService.update(phase.id, phAux).then(({ data: response }) => {
      if (response.internalError != null && response.internalError && response.message != null) {
        toast.error(response.message);
      } else {
        setIsEditing(false);
        toast.success(t("project_page.msg_success_phase_update"));
      }
      _fillProjectInfo();
    });
  }

  const formik = useFormik({
    initialValues: {
      name: '',
      duration: 0
    },
    validate: validate,
    onSubmit: (values, { setSubmitting, setValues }) => {
      handleSubmit(values);
    }
  });

  const prepareEdit = (ph: any) => {
    setAnchorEl(null);
    setIsEditing(true);
    formik.setValues(ph);
  }

  const deleteProjectPhase = (phase: any) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body custom-ui'>
            <h3 style={{ marginBottom: "1em" }}>{t("project_page.msg_delete_phase_confirm2")} <span className="dark">{phase.type_name + "?"}</span></h3>
            <p className="red"><strong>{t("project_page.msg_delete_phase_confirm3")}</strong></p>
            <div className="react-confirm-alert-button-group">
              <Button
                onClick={() => {
                  setShowLoading(true);
                  try {
                    // @ts-ignore
                    projectPhaseService.delete(phase.id).then(({ data: response }) => {
                      toast.success(t("project_page.msg_success_phase_delete"));
                      _fillProjectInfo();
                    }).catch((error: any) => toast.error("Ocurrió un error al eliminar la fase."));
                  } catch (error) {
                    console.log("Error #Users handleDelete" + JSON.stringify(error));
                    toast.error("Ocurrió un error al eliminar la fase.");
                  } finally {
                    setShowLoading(false);
                  }
                  onClose();
                }}>
                {t("project_page.msg_delete_task_confirm_yes")}
              </Button>
              <Button onClick={onClose}>{t("project_page.msg_delete_task_confirm_no")}</Button>
            </div>
          </div>
        );
      }
    });
  }

  return (
    <>
      {!hidePhaseAndTask && !isEditing &&
          <Paper
            variant="outlined"
            square
            sx={{ paddingTop: '3px', backgroundColor: 'rgba(215, 235, 240, 0.30)' }}
          >
            <Grid container spacing={1}>
              <Grid item xs={6.04} style={{padding:0, paddingLeft:'15px', minHeight: '38px'}} >
                <Typography sx={{ fontSize: '0.75rem', fontWeight: '700' }} >
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpen(!open)}
                  >
                    {open ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                  </IconButton>
                  {phase.type_name}
                </Typography>
              </Grid>
              <Grid item xs={1.8} style={{padding:0, background:'#D7EBF0', minHeight:'32px', marginTop: '-1px'}}></Grid>
              <Grid item xs={1.8} style={{padding:0, background:'#CFF1AB', minHeight:'32px', marginTop: '-1px'}}></Grid>
              <Grid item xs={1.9} style={{padding:0, background:'#DFDFDF', minHeight:'32px', marginTop: '-1px'}}></Grid>
              <Grid item xs={0.46 } style={{padding:0, minHeight:'32px', marginTop: '-1px'}}></Grid>

              <Grid item xs={0.3} />
              <Grid item xs={1.74} sx={{ display: "flex", justifyContent: 'center' }} >
                <TrueffortChipStatus
                  status_id={phase.status_id}
                  status_name={phase.status_name}
                />
              </Grid>
              <Grid item xs={1} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={1} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {phase.start_date === 0 ? '----------' : phase.start_date}
                </Typography>
              </Grid>
              <Grid item xs={1} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {phase.end_date === 0 ? '----------' : phase.end_date}
                </Typography>
              </Grid>
              <Grid item xs={1} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {phase.estimated_finish_date === 0 ? '----------' : phase.estimated_finish_date}
                </Typography>
              </Grid>
              <Grid item xs={0.9} style={{ background: '#D7EBF0', minHeight:'38px'}} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {phase.duration.toLocaleString()}
                </Typography>
              </Grid>
              <Grid item xs={0.9} style={{background:'#D7EBF0', minHeight:'38px'}}>
                <Typography  align="center" sx={{ fontSize: '0.75rem' }} >
                  {formatSeconds(phase.effort * 3600, false, false, false)}
                </Typography>
              </Grid>

              <Grid item xs={0.9} style={{background:'#CFF1AB', minHeight:'38px'}}>
                <Typography align="center" sx={{ fontSize: '0.75rem'}} >
                  {phase.registered_duration.toLocaleString()}
                </Typography>
              </Grid>

              <Grid item xs={0.9} style={{background:'#CFF1AB', minHeight:'38px'}}>
                <Typography align="center" sx={{ fontSize: '0.75rem', display:'flex', flexDirection:'column' }} >
                  <span>{formatSeconds(phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60, false, false, false)}</span>
                  <span>{phase.effort * 3600 == 0 ? "--" : ((phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60) / (phase.effort * 3600) * 100).toFixed(2) + '%'}</span>
                </Typography>
              </Grid>
              <Grid item xs={1} style={{background:'#DFDFDF', minHeight:'38px'}}>
                <Typography align="center" color={phase.days_deviation < 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem', fontWeight:'bold' }} >
                  {Math.abs(phase.days_deviation)}
                </Typography>
              </Grid>
              <Grid item xs={0.9} style={{background:'#DFDFDF', minHeight:'38px'}}>
                <Typography style={{fontWeight:'bold'}} align="center" color={(phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60) == 0 ? '' : (phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60) - (phase.effort * 3600) > 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem' }} >
                  {(phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60) == 0 ? 0 : formatSeconds(Math.abs((phase.registered_effort_hours * 3600 +
                    phase.registered_effort_minutes * 60) - (phase.effort * 3600)), false, false, false)}
                </Typography>
              </Grid>

              <Grid item xs={0.46} sx={{ display: 'flex', justifyContent: 'center' }} >
                {!showLoading ?
                  <>
                    {user.role.accessLevel >= MIN_LEVEL_LEADER &&
                      <Typography variant='subtitle2' color='#6693CB' align="center" 
                        onClick={handleClickOptions} style={{cursor: 'pointer'}}
                      >
                        <PendingIcon fontSize="small" />
                      </Typography>
                    }
                    <Menu
                      id="basic-menu"
                      sx={{
                        '& .MuiPaper-root': {
                          backgroundColor: '#050536'
                        }
                      }}
                      anchorEl={anchorEl}
                      open={openOptions}
                      onClose={handleCloseOptions}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      <MenuItem
                        onClick={() => prepareEdit(phase)}
                      >
                        <ListItemIcon>
                          <EditIcon
                            size="small"
                            sx={{ color: '#F5F5F5' }}
                          />
                        </ListItemIcon>
                        <ListItemText sx={{ color: '#F5F5F5' }}>
                          {t("elements.buttons.edit")}
                        </ListItemText>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleCloseOptions();
                          deleteProjectPhase(phase);
                        }}
                      >
                        <ListItemIcon>
                          <DeleteIcon
                            size="small"
                            //className="color-red"
                            sx={{ color: '#989898' }}
                          />
                        </ListItemIcon>
                        <ListItemText sx={{ color: '#989898' }} >
                          {t("delete")}
                        </ListItemText>
                      </MenuItem>
                    </Menu>
                  </> : <CircularProgress size={15} />
                } 
              </Grid>
            </Grid>
          </Paper>}
          {!hidePhaseAndTask && isEditing &&
          <Paper variant="outlined" square sx={{ padding: '10px', backgroundColor: '#DCDCDC' }} >
            <Grid container spacing={1} alignItems="center" >
              <Grid item xs={12} >
                <Typography sx={{ fontSize: '0.75rem', fontWeight: '700', paddingLeft:'30px' }} >
                  {phase.type_name}
                </Typography>
              </Grid>
              <Grid item xs={0.5} />
              
              <Grid item xs={1.5} sx={{ display: "flex", justifyContent: 'left'}} >
              <TrueffortChipStatus 
                status_id={phase.status_id}
                status_name={phase.status_name}
              />
              </Grid>
              <Grid item xs={1} />
              <Grid item xs={1} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {phase.start_date === 0 ? '----------' : phase.start_date}
                </Typography>
              </Grid>

              <Grid item xs={1} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {phase.end_date === 0 ? '----------' : phase.end_date}
                </Typography>
              </Grid>

              <Grid item xs={1} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {phase.estimated_finish_date === 0 ? '----------' : phase.estimated_finish_date}
                </Typography>
              </Grid>

              <Grid item xs={0.9} >
                <TextField
                  name="duration" type="number" min="1"
                  size="small"
                  variant="filled"
                  maxLength={6}
                  //label={t("estimation_page.effort_man_hours")}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.duration}
                  error={formik.errors?.duration && formik.touched?.duration ? t(formik.errors.duration) : null}
                />
              </Grid>

              <Grid item xs={0.9} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {formatSeconds(phase.effort * 3600, false, false, false)}
                </Typography>
              </Grid>

              <Grid item xs={0.9} >
                <Typography align="center" sx={{ fontSize: '0.75rem' }} >
                  {phase.registered_duration.toLocaleString()}
                </Typography>
              </Grid>

              <Grid item xs={0.9} >
                <Typography align="center" sx={{ fontSize: '0.75rem', display:'flex', flexDirection:'column' }} >
                  <span>{formatSeconds(phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60, false, false, false)}</span>
                  <span>{phase.effort * 3600 == 0 ? "--" : ((phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60) / (phase.effort * 3600) * 100).toFixed(2) + '%'}</span>
                </Typography>
              </Grid>
              <Grid item xs={1} style={{ minHeight:'38px'}}>
                <Typography align="center" color={phase.days_deviation < 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem', fontWeight:'bold' }} >
                  {Math.abs(phase.days_deviation)}
                </Typography>
              </Grid>
              <Grid item xs={0.9} style={{minHeight:'38px'}}>
                <Typography style={{fontWeight:'bold'}} align="center" color={(phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60) == 0 ? '' : (phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60) - (phase.effort * 3600) > 0 ? "error" : "#5eba00"} sx={{ fontSize: '0.75rem' }} >
                  {(phase.registered_effort_hours * 3600 + phase.registered_effort_minutes * 60) == 0 ? 0 : formatSeconds(Math.abs((phase.registered_effort_hours * 3600 +
                    phase.registered_effort_minutes * 60) - (phase.effort * 3600)), false, false, false)}
                </Typography>
              </Grid>

              <Grid item xs={0.5} >
                <Stack direction='column' alignItems='center' >
                  <TrueffortButton
                    style={{ maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px' }}
                    size="small"
                    color="secondary"
                    id="btnOptionsElement"
                    aria-controls={openOptions ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openOptions ? 'true' : undefined}
                    onClick={() => { formik.resetForm(); setIsEditing(false); }}
                  >
                    <CloseIcon />
                  </TrueffortButton>
                  <TrueffortButton
                    style={{ maxWidth: '30px', maxHeight: '30px', minWidth: '30px', minHeight: '30px' }}
                    size="small"
                    color="primary"
                    id="btnOptionsElement"
                    aria-controls={openOptions ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openOptions ? 'true' : undefined}
                    onClick={() => formik.handleSubmit()}
                  >
                    <SaveIcon />
                  </TrueffortButton>
                </Stack>
              </Grid>
            </Grid>
          </Paper>}

      <Collapse in={open} timeout="auto" unmountOnExit>
        {!hidePhaseAndTask && <Paper variant="outlined" square sx={{ 
          backgroundColor: '#F2E9FF', borderBottomColor: '#F2E9FF', borderTopColor: '#F2E9FF'}} >
          <Grid container spacing={1} border={0}>
            <Grid item xs={0.25} />
            <Grid item xs={5.78}>
              <Typography variant='caption' color='#553D74' sx={{ display: 'flex', alignItems: "center", fontWeight: '700' }} >
              <SvgIcon sx={{ marginRight: '6px', width: "16px", height: "16px" }} >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" fill="none">
                      <g clipPath="url(#clip0_578_12469)">
                        <path d="M8.93752 7.79167C8.87794 7.79167 8.81835 7.79167 8.75877 7.81L8.02085 6.32042C8.18413 6.16122 8.2962 5.95692 8.3427 5.73367C8.38921 5.51041 8.36804 5.27836 8.2819 5.06721C8.19577 4.85605 8.04859 4.67541 7.8592 4.54838C7.6698 4.42136 7.44682 4.35373 7.21877 4.35417C7.15919 4.35417 7.10419 4.35417 7.04002 4.3725L6.29294 2.88292C6.51294 2.67667 6.64585 2.38792 6.64585 2.0625C6.64585 1.75861 6.52513 1.46716 6.31025 1.25227C6.09536 1.03739 5.80391 0.916667 5.50002 0.916667C5.19613 0.916667 4.90468 1.03739 4.68979 1.25227C4.47491 1.46716 4.35419 1.75861 4.35419 2.0625C4.35419 2.38792 4.4871 2.67667 4.70252 2.88292L3.96002 4.3725C3.89585 4.35417 3.84085 4.35417 3.78127 4.35417C3.55323 4.35373 3.33024 4.42136 3.14084 4.54838C2.95145 4.67541 2.80427 4.85605 2.71814 5.06721C2.632 5.27836 2.61083 5.51041 2.65734 5.73367C2.70384 5.95692 2.81591 6.16122 2.97919 6.32042L2.24127 7.81C2.18169 7.79167 2.1221 7.79167 2.06252 7.79167C1.75863 7.79167 1.46718 7.91239 1.25229 8.12727C1.03741 8.34216 0.916687 8.63361 0.916687 8.9375C0.916687 9.24139 1.03741 9.53284 1.25229 9.74773C1.46718 9.96261 1.75863 10.0833 2.06252 10.0833C2.21299 10.0833 2.36199 10.0537 2.50101 9.99611C2.64003 9.93853 2.76635 9.85413 2.87275 9.74773C2.97915 9.64133 3.06355 9.51501 3.12113 9.37599C3.17872 9.23697 3.20835 9.08797 3.20835 8.9375C3.20835 8.61667 3.07544 8.32333 2.86002 8.11708L3.60252 6.6275C3.66669 6.64583 3.72169 6.64583 3.78127 6.64583C3.84085 6.64583 3.89585 6.64583 3.96002 6.6275L4.7071 8.11708C4.49169 8.32333 4.35419 8.61667 4.35419 8.9375C4.35419 9.24139 4.47491 9.53284 4.68979 9.74773C4.90468 9.96261 5.19613 10.0833 5.50002 10.0833C5.80391 10.0833 6.09536 9.96261 6.31025 9.74773C6.52513 9.53284 6.64585 9.24139 6.64585 8.9375C6.64585 8.63361 6.52513 8.34216 6.31025 8.12727C6.09536 7.91239 5.80391 7.79167 5.50002 7.79167C5.44044 7.79167 5.38085 7.79167 5.32127 7.81L4.58335 6.32042C4.79419 6.11417 4.9271 5.82542 4.9271 5.5C4.9271 5.17458 4.79419 4.88583 4.58335 4.67958L5.32127 3.19C5.38085 3.20833 5.44044 3.20833 5.50002 3.20833C5.5596 3.20833 5.61919 3.20833 5.67877 3.19L6.41669 4.67958C6.21044 4.88583 6.07294 5.17917 6.07294 5.5C6.07294 5.80389 6.19366 6.09534 6.40854 6.31023C6.62343 6.52511 6.91488 6.64583 7.21877 6.64583C7.27835 6.64583 7.33335 6.64583 7.39752 6.6275L8.1446 8.11708C7.92919 8.32333 7.79169 8.61667 7.79169 8.9375C7.79169 9.24139 7.91241 9.53284 8.12729 9.74773C8.34218 9.96261 8.63363 10.0833 8.93752 10.0833C9.24141 10.0833 9.53286 9.96261 9.74775 9.74773C9.96263 9.53284 10.0834 9.24139 10.0834 8.9375C10.0834 8.63361 9.96263 8.34216 9.74775 8.12727C9.53286 7.91239 9.24141 7.79167 8.93752 7.79167Z" fill="#27535E" />
                      </g>
                      <defs>
                        <clipPath id="clip0_578_12469">
                          <rect width="11" height="11" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </SvgIcon>
                {t("home.tasks")}
              </Typography>
            </Grid>
            <Grid item xs={1.8} style={{background:'#D7EBF0', minHeight:'32px', marginTop: '3px'}}></Grid>
            <Grid item xs={1.8} style={{background:'#CFF1AB', minHeight:'32px', marginTop: '3px'}}></Grid>
            <Grid item xs={1.9} style={{background:'#DFDFDF', minHeight:'32px', marginTop: '3px'}}></Grid>
            <Grid item xs={0.47} style={{minHeight:'32px', marginTop: '3px'}}></Grid>
          </Grid>
        </Paper>}

        {phase.tasks.map((tk: any, j: number) => (
          <ProjectDetailTaskRow
            key={tk.id}
            element={el}
            phase={phase}
            task={tk}
            users={users}
            states={states}
            _fillProjectInfo={_fillProjectInfo}
            taskType={
              taskTypes.find((taskT: any) =>
                taskT.id === tk.type_id
              )
            }
            hidePhaseAndTask={hidePhaseAndTask}
            project={project}
            tasks={tasks}
            priorityTypes={priorityTypes}
            hasSecuency={hasSecuency}
          />
        ))}
      </Collapse>
    </>
  );
}

export default ProjectDetailPhaseRow;